<template>
  <div
    class="d-flex-column justify-start align-start safe_secure_container"
    :class="[hide && 'hide']"
  >
    <div class="d-flex-row space-between safe_secure_payments">
      <div
        class="d-flex-column justify-start align-start"
        :class="[showImage && 'flex-8']"
      >
        <div class="d-flex-row justify-start">
          <ShieldContained />
          <div class="d-flex-column align-start gap-0">
            <h5 class="t-white font-family-2 bold-l">
              {{ $t("calculators_common.safe_secure_payments") }}
            </h5>
            <p
              class="t-white font-family-2 regular-s"
              :class="[!showImage && 'white-space-no']"
            >
              {{ $t("calculators_common.safe_secure_payments_description") }}
            </p>
          </div>
        </div>

        <div class="d-flex-row justify-start" style="gap: 12px">
          <div
            class="payment_method"
            v-for="paymentmethod in paymentMethods"
            :key="paymentmethod"
          >
            <img
              class="method_image"
              :src="`/images/payments/methods/${paymentmethod}.webp`"
              :alt="paymentmethod + 'payment method icon'"
            />
          </div>
        </div>
      </div>

      <div class="d-flex-row justify-end flex-2 md-hide" v-if="showImage">
        <img
          src="../../../public/images/safe_secure.webp"
          class="safe_secure_image"
        />
      </div>
    </div>
    <!-- <mobile-review-banner type="trustpilot" :reviews="3084" /> -->
    <div class="d-flex-row gap-5 flex-wrap">
      <p class="t-grey regular-m font-family-2">
        {{ $t("app.pay_cart_text_1") }}
      </p>
      <NuxtLinkLocale class="t-white regular-m font-family-2" href="/">
        {{ $t("app.pay_cart_text_2") }}
      </NuxtLinkLocale>
      <p class="t-grey regular-m font-family-2">
        {{ $t("app.pay_cart_text_3") }}
      </p>
      <a
        class="t-white regular-m font-family-2"
        href="https://www.iubenda.com/terms-and-conditions/97786814"
        target="_blank"
        referrerpolicy="no-referrer"
      >
        {{ $t("app.pay_cart_text_4") }}
      </a>
      <p class="t-grey regular-m font-family-2">
        {{ $t("app.pay_cart_text_5") }}
      </p>
      <a
        class="t-white regular-m font-family-2"
        href="https://www.iubenda.com/privacy-policy/97786814"
        target="_blank"
        referrerpolicy="no-referrer"
      >
        {{ $t("app.pay_cart_text_6") }}
      </a>
    </div>
  </div>
</template>

<script>
import ShieldContained from "~/components/icons/ShieldContained.vue";
import MobileReviewBanner from "~/components/banners/MobileReviewBanner.vue";
export default {
  data() {
    return {
      paymentMethods: [
        "paypal",
        "mastercard",
        "visa",
        "gpay",
        "apay",
        "americanexpress",
        "unionpay",
        "jcb",
      ],
    };
  },
  components: {
    ShieldContained,
    MobileReviewBanner,
  },
  props: {
    showImage: {
      default: false,
    },
    hide: {
      default: false,
    },
  },
};
</script>
